import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    projects: [],
    searchFilter: "",
    topPerforming: [],
    leastPerforming: [],
    projectsUsage: {dates: {} , sortedDates: []},
    exclusionUsage: {dates: {}, sortedDates: []},
    filteredOverview: {
        projects: [],
        searchFilter: "",
        topPerforming: [],
        leastPerforming: [],
        projectsUsage: {dates: {} , sortedDates: []},
        exclusionUsage: {dates: {}, sortedDates: []}
    }
}

const projectsSlice = createSlice({
    name: "projects",
    initialState,
    reducers: {
        resetProjects: (state) => {
            Object.assign(state, initialState)
        },
        setProjects: (state, {payload}) => {
            const target = payload.target
            if(target) { state[target].projects = payload.projects ; return }
            state.projects = payload.projects
        },
        setProjectSearchFilter: (state, {payload}) => {
            state.searchFilter = payload.projectName
        },
        setTopPerforming: (state, {payload}) => {
            const target = payload.target
            if(target) { state[target].topPerforming = payload.topPerforming ; return }
            state.topPerforming = payload.topPerforming
        },
        setLeastPerforming: (state, {payload}) => {
            const target = payload.target
            if(target) { state[target].leastPerforming = payload.leastPerforming ; return }
            state.leastPerforming = payload.leastPerforming
        },
        setProjectsUsage: (state, {payload}) => {
            const target = payload.target
            if(target) { state[target].projectsUsage = payload ; return }
            state.projectsUsage = payload
        },
        setExclusionUsage: (state, {payload}) => {
            const target = payload.target
            if(target) { state[target].exclusionUsage = payload ; return }
            state.exclusionUsage = payload
        }
    }
})

export const { setProjects, setProjectSearchFilter, setTopPerforming, setLeastPerforming, setProjectsUsage, resetProjects, setExclusionUsage } = projectsSlice.actions

export default projectsSlice.reducer